define('Responsive/controllers/CardViewController',['require','exports','module','./ViewController','message-service/message-service','../vendor','../util/renderComplete','../delegates/SwipeableViewDelegate','../util/noop'],function(require,exports,module){
    var ViewController = require('./ViewController');

    var messageService=require('message-service/message-service'),
        ReVendor = require('../vendor'),
        ReRenderComplete = require( '../util/renderComplete' ),
        SwipeableViewDelegate = require( '../delegates/SwipeableViewDelegate' ),
        _noop = require( '../util/noop' );

    // Add private variables here
    var Superclass,
        doc = document,
        // Add private methods here
        toggleView = function (that) {
            var to,
                from,
                cb,
                isDocked = that.isDocked;
            if (that.dockedSide === "right") {
                from = isDocked ? 1 : 0;
                to = isDocked ? 0 : -1;
            } else {
                from = isDocked ? -1 : 0;
                to = isDocked ? 0 : 1;
            }
            that.uiDelegate.scrollTo(to,from,toggleCallback);
        },

        toggleCallback=function(){
            if (this.isDocked && this.isLayer && this.isViewLoaded()) {
                this.viewWillDisappear();
                this.viewDidDisappear();
            }
        };



    // Constructor
    function CardViewController(dockingSide, childController, isLayer) {
        // Call super constructor
        Superclass.constructor.call(this);
        var options = {};
        if(typeof dockingSide !== 'string' && typeof dockingSide == 'object'){
            options = dockingSide;
            dockingSide = options.dockingSide;
            childController = childController || options.childController;
            isLayer = options.isLayer !== undefined ? options.isLayer : isLayer;
        }
        this.options = options;
        this.dockedSide = dockingSide;
        this.dockedEvent = 'swipe' + dockingSide.charAt(0).toUpperCase() + dockingSide.substr(1);
        this.isDocked = true;
        this.isLayer = isLayer;
        this.contentWrapper = doc.createElement("div");
        this.closerDiv = doc.createElement("div");
        this.closerDiv.style.top = "0";
        this.closerDiv.style.width = "40px";
        this.contentWrapper.className = "contentWrapper";
        this.fullscreen = false;
        this.onClose = _noop;
        this.referenceName = this.dockedSide.toLowerCase() + "Panel";

        if (childController) {
            childController.parentViewController = this;
            this.childViewControllers.push(childController);
        }
    }

    CardViewController.prototype.swipe = true;
    CardViewController.setSwipe = function (val) {
        CardViewController.prototype.swipe = !!val;
    };

    // Prototype Inheritence
    ViewController.spawn(CardViewController).define({
        loadView: function () {
            var that = this,
                page = (this.dockedSide === 'right' ? -1 : 1);
            Superclass.loadView.call(this);
            this.control = doc.createElement("div");
            this.$view = $(this.view);
            this.swipe = this.swipe && !!ReVendor.useTransition;
            this.setClassName(this.view, "CardViewController");
            this.setClassName(this.view, "CardView-" + this.dockedSide);
            this.setClassName(this.view, this.isLayer ? "layer" : "pullTab");
            this.setClassName(this.control, "close");
            this.toggle = function (e) {
                toggleView(that);
                if(e){
                    e.stopPropagation();
                }
            };
            if (this.isLayer) {
                if(!this.swipe){
                    this.setClassName(this.view, "noTransition");
                }
//				this.control.innerHTML="close";
                this.view.appendChild(this.control)
                this.control.addEventListener('click', this.toggle);
            }
            this.view.appendChild(this.contentWrapper);
            this.uiDelegate=new SwipeableViewDelegate({
                    swipeDistance: 0.2,
                    swipeToSpeed : this.options.swipeToSpeed,
                    startView: page,//(this.isLayer ? page - page * 1 : page),
                    stayInBounds: false,
                    watchers: {
                        canSwipe: function () {
                            return that.swipe;
                        },

                        start: function () {
                            var isDocked = this.isDocked,
                                side = this.dockedSide;
                            return {
                                // Should wrap these checks in a method
                                "1": (isDocked && side === "right") || (!isDocked && side === "left"),
                                "-1": (!isDocked && side === "right") || (isDocked && side === "left")
                            };
                        },
                        change: function () {

                        },
                        beforeChange: function () {
                            var docked = this.isDocked;
                            this.isDocked = !this.isDocked;
                            this.$view[docked ? 'addClass' : 'removeClass']('open');
                        }
                    }
                });
            this.uiDelegate.create(this.view,this);

            this.$view.on('dblclick', function (e) {
                // I imagine this will be parameterized for future builds
                // if (!that.isLayer) {
                //     e.stopPropagation();
                //     toggleView(that);
                // }
            }).on('click', function (e) {
                if (!that.isLayer && e.target===e.currentTarget) {
                    e.stopPropagation();
                    toggleView(that);
                }
                return true;
            });
			
        },

        viewDidAppear: function () {
            var that=this;
            Superclass.viewDidAppear.call(this);
            var controller = this.childViewControllers[0],
                controllerView;
            if (controller) {
                this.contentWrapper.setAttribute('data-loading', true);
                controller.viewWillAppear();
                controllerView = controller.getView();
                this.contentWrapper.appendChild(controllerView);
                controller.viewDidAppear();
                this.contentWrapper.setAttribute('data-loading', false);
            }
            this.register();
            ReRenderComplete(function(){

                if (that.isDocked && that.isLayer) {
                    toggleView(that);
                }

            });

            this.checkHeight();
        },

        viewWillDisappear: function () {
            if (this.isLayer && !this.isDocked) {
                toggleView(this);
            }
            Superclass.viewWillDisappear.call(this);
            messageService.publish("unregisterViewComponent", this);
        },

        draw: function () {
            Superclass.draw.call(this);
        },


        setAvailableHeight: function (name) {
            Superclass.setAvailableHeight.call(this, false);
            var height = this.availableHeight;

            this.availableHeight = this.isLayer || height === 'auto' ? height : height - 30;
        },
        show : function() {
            this.enabled = true;
            this.disabled = false;
            this.getView().style.opacity = 1;
            this.getView().style.visibility = "visible";
        },

        hide : function() {
            this.enabled = false;
            this.disabled = true;

            /* 
             * Setting opacity to 0 before visibility to fix elements 
             * diappearing at different rates.
             */
            this.getView().style.opacity = 0;
            this.getView().style.visibility = "hidden";
        },

        openTab : function(payload, evt) {
            if (this.isDocked === true) {
                toggleView(this);
            }
        },

        register : function() {
            messageService.publish("registerViewComponent", this);
        }

    });

    Superclass = CardViewController.superclass;
    // Add view controller class to Responsive library
    return CardViewController;

});

